import { useArrayDataSource } from '@epam/uui-core';
import { FlexRow, LabeledInput, PickerInput } from '@epam/uui';
import React from 'react';
import { FilterOptionProps } from './FilterDropdown.model';

const FilterOption = ({ setting, value, onValueChange }: FilterOptionProps) => {
  const optionsSource = useArrayDataSource(
    {
      items: setting.options,
      getId: (item) => item,
    },
    [setting.options],
  );

  return (
    <FlexRow columnGap="12" padding="18">
      <LabeledInput htmlFor={setting.key} label={setting.label}>
        <PickerInput<string, string>
          dataSource={optionsSource}
          entityName={setting.entityName}
          getName={(item) => item}
          id={setting.key}
          maxItems={setting.maxItems}
          placeholder={setting.placeholder}
          searchPosition="input"
          selectionMode={setting.selectionMode}
          value={value}
          valueType="id"
          onValueChange={onValueChange}
        />
      </LabeledInput>
    </FlexRow>
  );
};

export default FilterOption;
